/**
 * Importação da classe genérica para requisições em serviços
 */
import GenericCrud from 'services/crud/GenericCrud';

/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

export default class FeatureCollection extends GenericCrud {
  constructor() {
    super('camada');
  }

  /**
   * Método para obtenção das feições de uma camada
   *
   * @param {string} workspace Nome da camada composto pelo workspace da camada
   * @param {string} layerName Nome da camada
   */
  async get(
    workspace,
    layerName,
    allFeatures = true,
  ) {
    try {
      let params = {
        workspace: workspace,
        layer: layerName,
        allFeatures: allFeatures
      };

      let attributes = await axios(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}`,
        { params }
      );      
      
      if (attributes?.data?._embedded?.camada?.length > 0) {
        let attributesPrepared = attributes.data._embedded.camada[0].features.map(
          (attr) => {
            let newAttr = attr.properties;
            if (attr.properties.envelope) {
              newAttr.envelope = JSON.parse(attr.properties.envelope);
              // newAttr.bbox = L.latLngBounds(
              //   [newAttr.envelope.bbox[1], newAttr.envelope.bbox[0]],
              //   [newAttr.envelope.bbox[3], newAttr.envelope.bbox[2]]
              // );              
            }
            if (attr.bbox) {
              newAttr.bbox = L.latLngBounds(
                [attr.bbox[1], attr.bbox[0]],
                [attr.bbox[3], attr.bbox[2]]
              );
            }
            return newAttr;
          }
        );
        return {
          attributes: attributesPrepared,
          totalFeatures: attributes.data._embedded.camada[0].totalFeatures,
        };
      } else {
        return { attributes: [] };
      }      
    } catch (error) {
      console.error(error);
    }
  }
}
